import { FC, MutableRefObject, useMemo } from 'react';
import { Channel } from 'stream-chat';
import { makeStyles } from '@material-ui/styles';
import { Event, Session } from '@bizzabo/entities';
import { Theme } from '@bizzabo/design-system';
import { UserRole } from '../../types/UserRole';
import { ISessionChatCtx, SessionChat } from '../../index';
import useChannels from '../../decorators/channels';
import SessionChatCtx from '../../context/SessionChatCtx';

interface ISessionChat {
    accountId: number;
    portalId: number;
    event: Event;
    session: Session;
    channelId: string;
    channelTitle: string;
    sessionChatContainer: MutableRefObject<HTMLElement>;
    chatUserRole?: UserRole;
}

const OrganizerChat: FC<ISessionChat> = ({
    accountId,
    portalId,
    event,
    session,
    channelId,
    channelTitle,
    sessionChatContainer,
    chatUserRole,
}) => {
    const classes = useStyles();
    const { channels } = useChannels(accountId, portalId, session);

    // for portal eventId = portalId
    const sessionChatCtx: ISessionChatCtx = useMemo(
        () => ({
            accountId: accountId,
            eventId: portalId,
            sessionId: session.id,
            event: event,
            onThreadView: () => {},
        }),
        [event.id, session.id]
    );

    if (!channels) {
        return (
            <div className={classes.organizerChatLoadingChat}>
                <div className={classes.loader} />
            </div>
        );
    }

    const chatChannel = {
        title: channelTitle,
        channel: channels.find((channel: Channel) => channel.id === channelId),
    };

    return (
        <SessionChatCtx.Provider value={sessionChatCtx}>
            <SessionChat
                chatChannel={chatChannel}
                sessionChatContainer={sessionChatContainer}
                chatUserRole={chatUserRole}
            />
        </SessionChatCtx.Provider>
    );
};

const useStyles = makeStyles(
    (theme: Theme) => ({
        '@global': {
            '@keyframes orgChatSpinner': {
                '0%': { transform: 'rotate(0deg)' },
                '100%': { transform: 'rotate(360deg)' },
            },
        },
        organizerChatLoadingChat: {
            height: '100%',
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
        },
        loader: {
            border: '6px solid #f3f3f3',
            borderTop: `6px solid ${theme.customization.interactive.C10}`,
            borderRadius: '50%',
            width: 80,
            height: 80,
            animation: 'orgChatSpinner 1s linear infinite',
        },
    }),
    {
        classNamePrefix: 'OrganizerChat',
    }
);

export default OrganizerChat;
